import Vue from 'vue'

Vue.component('AcordionA', () => import('./AcordionA.vue'))
Vue.component('TabsA', () => import('./TabsA.vue'))
Vue.component('TabsB', () => import('./TabsB.vue'))
Vue.component('TabsC', () => import('./TabsC.vue'))
Vue.component('LineaTiempoA', () => import('./LineaTiempoA.vue'))
Vue.component('LineaTiempoB', () => import('./LineaTiempoB.vue'))
Vue.component('PasosA', () => import('./PasosA.vue'))
Vue.component('SlyderA', () => import('./SlyderA.vue'))
Vue.component('SlyderB', () => import('./SlyderB.vue'))
Vue.component('SlyderC', () => import('./SlyderC.vue'))
Vue.component('SlyderD', () => import('./SlyderD.vue'))
Vue.component('ModalA', () => import('./ModalA.vue'))
